module.exports = {"id":"224538","name":"Pedro Nuno","rating":"72","photo":"./data/images/photos/0/224538.png","club":{"name":"Tondela","logo":"./data/images/clubs/Tondela.png"},"positions":["MOC","MC","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/PedroNuno0.json
// module id = 3420
// module chunks = 0